module.exports = __webpack_public_path__ + "static/media/franchisee-on.af2c3b0a.svg";